/**
 * Shared editor constants — used by both Play and Concept editors
 */

/** Debounce delay for player position updates during drag (ms) */
export const POSITION_DEBOUNCE_MS = 150

/** How long the "saved" status indicator shows before returning to idle (ms) */
export const SAVE_STATUS_DISPLAY_MS = 3000

/** How long the error status indicator shows before returning to idle (ms) */
export const SAVE_ERROR_DISPLAY_MS = 5000
